/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* How partitioning is determined for ingestion data
*/
export enum PartitionType {
  PARTITION_TYPE_BUCKET_PATH = 'BUCKET_PATH'
}
